import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconShieldBreak: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconShieldBreak"><Path d="M17.059 15.1092L1.63583 2.69543L0.695312 3.86395L3 5.71894V13C3 17.9706 7.02944 22 12 22C14.8442 22 17.3802 20.6807 19.0295 18.6207L22.3638 21.3045L23.3043 20.1359L19.8692 17.371C19.8739 17.3624 19.8787 17.3538 19.8835 17.3452L17.059 15.1092Z" fill="currentColor"/><Path d="M21 13C21 14.0356 20.8251 15.0303 20.5032 15.9562L5.75422 4.08503L12 1.4353L21 5.25348V13Z" fill="currentColor"/></CentralIconBase>;
});

export default IconShieldBreak;
